<script lang="ts">
  export let author: string;
</script>

<footer class="footer mt-5">
  <div class="content has-text-centered">
    <p>
      <strong>This Web Application was created</strong> by
      <a href="https://github.com/grandemayta">{author}</a>. The source code is licensed
      <a href="http://opensource.org/licenses/mit-license.php">MIT</a>.
    </p>
  </div>
</footer>
